export const getUnits = (state) => state?.units || {};
export const getUnitById = (state, unitId) => state?.units?.[unitId] || {};
